'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
var CorporateDiscount = {
	init: function init() {
		// alert('cart rendered')
	},
	donate: function donate(_donate) {

		cart.items.map(function (item, index) {
			item.index = index;return item;
		}).filter(function (i) {
			return JSON.stringify(i.properties._tags).includes('CorporateDiscount');
		}).forEach(function (item, index) {
			console.log(item.index);
			if (item.properties['Corporate Donation'] != _donate) {
				item.properties['Corporate Donation'] = _donate;
				Neptune.cart.changeItem(item.index, item.quantity, item.properties);
			}
		});
	},
	calculate: function calculate() {
		var donated = _n.sum(cart.items.map(function (item) {
			var discount = {};
			if (!item.properties._tags) return discount;
			discount.tiers = item.properties._tags.filter(function (tag) {
				return tag.includes('CorporateDiscount');
			}).map(function (tag) {
				return {
					quantity: parseInt(tag.split('-')[1]),
					discount: parseInt(tag.split('-')[2])
				};
			});
			discount.applied = 0;
			discount.tiers.forEach(function (tier) {
				if (item.quantity >= tier.quantity) discount.applied = item.original_line_price * (tier.discount / 100);
			});
			return discount;
		}).map(function (d) {
			return d.applied;
		}));
		_n.qsa('[data-corporate-discount]').forEach(function (el) {
			console.log('Exists!');
			el.innerHTML = '$' + (donated / 100).toFixed(2);
		});
	}
};

window.CorporateDiscount = CorporateDiscount;

document.addEventListener('template:rendered', function (e) {
	if (e.detail.info.topic == 'cart' && e.detail.info.el == _n.qs('section[neptune-template*=cart]')) {
		CorporateDiscount.calculate();
	}
});

exports.default = CorporateDiscount;